import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ColumnType } from 'src/app/models/enums/column-type';
import { FilterType } from 'src/app/models/enums/filter-type';
import { FilterInfos } from 'src/app/models/server/core/filter-infos';
import { Results } from 'src/app/models/server/core/results-T';
import { EmailAddress } from 'src/app/models/server/email-address';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class EmailAddressesService extends ServiceBase {
    /**
     * Constructeur
     * */
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        private viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Retourne la liste des dossier pours les workflows
     * @returns liste de dossier
     */
    ListSendingEmailAddress(): Observable<EmailAddress[]> {
        let filters: FilterInfos[] = [];
        let filter = new FilterInfos();
        filter.columnName = 'sendingEnabled';
        filter.filterType = FilterType.Boolean;
        filter.type = ColumnType.Boolean;
        filter.value = 'true';

        filters.push(filter);

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(null),
                filters: this.getHeader(filters),
                context: this.getHeader(null),
            }),
        };

        // Appel de la Web Api
        return this.http.get<Results<EmailAddress>>(this.baseUrl + `/api/organizations/${this.organizationId}/emailAddresses`, httpOptions).pipe(
            map((x) => {
                return x.value;
            })
        );
    }
}
